






































import { Card, Button } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'
import * as graph from '@shared/types/graphql'
import EditModal from '@/components/EditModal.vue'
import AudienceInfo from '@/components/AudienceInfo.vue'
import AudienceBuilder, { AudienceEmission, Stages } from '@/components/AudienceBuilder/AudienceBuilder.vue'
import store from '@/store'
import { processAudience } from '@/utilities/audience-mappers'
import AudienceManagerModal, { getSelectableAudiences } from '@/components/AudienceBuilder/AudienceManagerModal.vue'
import Audience from '@/components/AudienceBuilder/Audience'

@Component({
  components: {
    Card,
    Button,
    EditModal,
    AudienceBuilder,
    AudienceInfo,
    AudienceManagerModal
  }
})
export default class AudienceDetails extends Vue {
  @Prop({ required: true }) audience!:Pick<graph.Audience, 'name' | 'drops' | 'payload' | '_id'> | null
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) organizationId!: string
  @Prop({ required: true }) accountId!: string
  @Prop({ default: false }) editable!: boolean
  @Prop({ default: false }) saving!: boolean

  fullAudience: Partial<Audience> | null = null
  edit = false
  stage = Stages.LIBRARY
  newAudience: AudienceEmission | null = null

  get processedAudience () {
    if (!this.audience) return null
    return processAudience(this.audience)
  }

  get selectableAudiences () {
    return getSelectableAudiences(store.getters.workspace.workspaceAudiences)
  }

  get accountAudiences () {
    return store.getters.workspace.accountAudiences
  }

  setStage (newStage: Stages) {
    this.stage = newStage
  }

  clearAudience () {
    this.newAudience = null
  }

  setAudience (payload: AudienceEmission) {
    this.newAudience = payload
  }

  setAudienceManagerModalAudience (audience: Audience) {
    this.newAudience = { audience: { id: audience.id, title: audience.name } }
    this.save()
  }

  save () {
    if (!this.newAudience) {
      this.edit = false
    } else {
      const { audience } = this.newAudience
      const { id, title } = audience
      this.$emit('update', { id, title })
      this.edit = false
    }
  }

  cancel () {
    this.edit = false
  }

  get showNewAudienceManagerModal () {
    return store.getters.feature.hasFeature('newTestExperience')
  }
}
